import { hash } from '@ember/helper';

import svgJar from 'ember-svg-jar/helpers/svg-jar';
import { and, not } from 'ember-truth-helpers';

import Component from 'umg-ember-backend/components/record-detail/forms';
import AssetPreview from 'umg-ember-backend/components/ui/asset-preview';
import Form from 'umg-ember-backend/components/ui/form';

export default class RecordDetailFormsWebSeriesComponent extends Component {
  // Defaults
  typeOptions = [
    {
      label: 'Series',
      value: 'Series',
    },
    {
      label: 'Era',
      value: 'Era',
    },
    {
      label: 'Mood',
      value: 'Mood',
    },
  ];

  // Template
  <template>
    <Form @model={{@model}} @showErrors={{@showErrors}} as |form|>
      <div class='o-layout'>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.sections.variant
            @availableLanguages={{this.availableLanguages}}
          />

          <form.fieldset @titleKey='general' as |fieldset|>
            <fieldset.field
              @property='cmsState'
              @type='select-value'
              @options={{this.cmsStateOptions}}
            />

            {{#if this.isParent}}
              <fieldset.field
                @property='cmsLanguageId'
                @type='select-value'
                @options={{this.availableLanguages}}
              />
            {{/if}}

            <fieldset.field @property='headline' />
            <fieldset.field @property='description' @type='text-editor' />
          </form.fieldset>

          <form.fieldset @titleKey='keywords' as |fieldset|>
            <fieldset.field @property='keywords' />
          </form.fieldset>

          <form.sections.seo />
        </div>
        <div class='o-layout__item u-1/1 u-1/2@tablet'>
          <form.fieldset @titleKey='configuration' as |fieldset|>
            <fieldset.field @property='visibleInList' @type='checkbox' />
            <fieldset.field
              @property='type'
              @type='select-value'
              @options={{this.typeOptions}}
            />

            <fieldset.field
              @property='channels'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />

            <fieldset.field
              @property='urlAliases'
              @type='has-many'
              as |urlAlias|
            >
              {{svgJar
                (if
                  (and (not urlAlias.parent) (not urlAlias.isNew))
                  'star'
                  'star-outline'
                )
                class='u-icon'
              }}
              {{urlAlias.displayLabel}}
            </fieldset.field>

            <fieldset.field
              @filters={{hash assetFolderId='1'}}
              @property='cover'
              @options={{hash allowedFolder='100'}}
              @type='belongs-to'
              as |record|
            >
              <AssetPreview @asset={{record}} />
            </fieldset.field>
          </form.fieldset>

          <form.fieldset @titleKey='productFamilies' as |fieldset|>
            <fieldset.field
              @property='productFamilies'
              @type='has-many'
              @on={{hash openNewRecord=false}}
            />
          </form.fieldset>

          <form.sections.meta />
        </div>
      </div>
    </Form>
  </template>
}
